import { render, staticRenderFns } from "./AppNavBar.vue?vue&type=template&id=5af9c38e"
import script from "./AppNavBar.vue?vue&type=script&lang=js"
export * from "./AppNavBar.vue?vue&type=script&lang=js"
import style0 from "./AppNavBar.vue?vue&type=style&index=0&id=5af9c38e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports